// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__yUdzj","title":"AfterFrontImage_title__3tcSP"};